import * as Api from '@ViewModels';
import React from 'react';
import { FormState } from 'react-hook-form';
import { toast } from 'sonner';
import { EventRegistrationFormData, TabValues } from '../utils';

// Hook for form validation and error handling (new - uses setState)
export const useEventRegistrationFormValidation = ({
	formState,
	setState,
}: {
	formState: FormState<EventRegistrationFormData>;
	setState: React.Dispatch<
		React.SetStateAction<{
			enableRequestAttendeesToRSVP: boolean;
			fileInputModalOpen: boolean;
			now: Date;
			selectedImage: Api.IFileAttachment | null;
			customFormIsDisabled: boolean;
			selectedTab: TabValues;
			showEditSurveyName: boolean;
			showReorderModal: boolean;
		}>
	>;
}) => {
	React.useEffect(() => {
		if (formState.errors?.eventName?.message) {
			setState(
				(prevState: {
					enableRequestAttendeesToRSVP: boolean;
					fileInputModalOpen: boolean;
					now: Date;
					selectedImage: Api.IFileAttachment | null;
					customFormIsDisabled: boolean;
					selectedTab: TabValues;
					showEditSurveyName: boolean;
					showReorderModal: boolean;
				}) => ({
					...prevState,
					showEditSurveyName: true,
				})
			);
		}
		if ((formState.errors?.payments as { cost?: { message?: string } })?.cost?.message) {
			toast.error('Please enter a valid event cost');
		}
	}, [formState.errors, setState]);
};
